(function() {
	'use strict';

	angular
		.module('as.groups')
		.controller('groupSettingsCtrl',groupSettingsCtrl);

	groupSettingsCtrl.$inject = ['$scope','groupDetail','$http','ModalService','bootModal','$stateParams','$ocLazyLoad','$state','groupsService','$rootScope','$filter','$timeout','$q','Upload'];
	function groupSettingsCtrl($scope,groupDetail,$http,ModalService,bootModal,$stateParams,$ocLazyLoad,$state,groupsService,$rootScope,$filter,$timeout,$q,Upload) {
		//variables
		$scope.membersAddition=true;
		$scope.selectedPeople = [];
		$scope.addMapping=false;
		$scope.lock_actions = 0;
		$scope.selectedPeopleToRemove = [];
		$scope.filterShow = $stateParams.filter;
		if($stateParams.src && $stateParams.src=='manageGroups'|| $stateParams.src=='NewChapterCreation'){
			$scope.goToMainGroup = true;
			delete $stateParams.src;
		}
		else if($stateParams.src)
		{
			console.log($stateParams.src);
			$scope.scrollTo=$stateParams.src;
			

		}
		if($scope.scrollTo)
		{
			$timeout(function() {
				var div = document.getElementById($scope.scrollTo);
				if(div)
					div.scrollIntoView({ behavior: "smooth", block: "start"});
			  },1000);
			
		}  
		$scope.addMember = true;
		$scope.deleteMember = false;
		$scope.isFetching=false;
		


		//function bindings
		$scope.tagSelectedPeople = tagSelectedPeople;
		$scope.bulkPrompt = bulkPrompt;
		$scope.AddCoordModal=AddCoordModal;
		$scope.editCoordModal=editCoordModal;
		$scope.deleteCoordModal=deleteCoordModal;
		$scope.removeSelectedPeople = removeSelectedPeople;
		$scope.reloadState = reloadState;
		$scope.goBackToPrevPage = goBackToPrevPage;
		$scope.checkLink = checkLink;
		$scope.setOriginalData = setOriginalData;
		$scope.searchLocation=searchLocation;
		$scope.deleteLocation=deleteLocation;
		$scope.updateGroup = updateGroup;
		$scope.updateMapping=updateMapping;
		$scope.checkAbout = checkAbout;
		$scope.checkName = checkName;
		$scope.goToAdminDashboard = goToAdminDashboard;
		$scope.loadCroper=loadCroper;
		$scope.loadCroper2=loadCroper2;
		$scope.check_radio_status = check_radio_status;
		$scope.check_if_group_has_chat_enabled = check_if_group_has_chat_enabled;
		$scope.goBackToPrevPage2=goBackToPrevPage2;
		$scope.changeMemberAddChoice = changeMemberAddChoice;
		$scope.mapToggle=mapToggle;
		$scope.removeLocationToggle=removeLocationToggle;
		$scope.onChange=onChange;
		$scope.nameEmail=$filter('asPortalLang')('Group_Input_Name_Email',"Type name or email");
		$scope.enterUrl=$filter('asPortalLang')('Enter_URL',"Enter URL");
		$scope.enterLocation=$filter('asPortalLang')('Sevt_Enter_Location',"Enter Location");
		$scope.getCoordLength = function(coord){
			if(coord && coord.length>0){
				return {'coordLength':coord.length};
			}
			return {'coordLength':0};
		}
		$scope.uitreeLibs = [
			{
				"name": "ui.tree",
				"files": [staticContentCdnUrl+"./libs/uitree/dist/angular-ui-tree.min.js","css!"+staticContentCdnUrl+"./libs/uitree/dist/angular-ui-tree.min.css"]
			}
		];
		$scope.treeOptions = {
			dropped: reorderGroups,
		};
		$scope.showTypeDropdown = false;
		$scope.toggleDropdown = function(){
			$scope.showTypeDropdown = !$scope.showTypeDropdown;
		}
		$scope.changeChapterPrivacy = function(privacy){
			if(!angular.isDefined($scope.group.extra))
				$scope.group.extra = {};
			if(!angular.isDefined($scope.group.extra.privacy))
				$scope.group.extra.privacy = 1;
			$scope.group.extra.privacy = privacy;
		}

		activate();	

		function activate() {
			if(groupDetail.success == 1 && groupDetail.data){
				$scope.group = groupDetail.data;
				if($scope.group && $scope.group.mapping){
					checkCities($scope.group.mapping);
				}
				$scope.filter = {"tags":{"tag_id":$scope.group.id},"include_demised":true};
				
				if(angular.isUndefined($scope.group['attributes']))
					$scope.group['attributes'] = {};
				createEditData();
			}
			if(!$ocLazyLoad.isLoaded('as.search')) 
            {
                $ocLazyLoad.load({
                    "name": "as.search",
                    "files": [staticContentCdnUrl+"./dist/search.min.js?v="+window.jsVersion]
                });
            }
		as_upgrade(10);
		}

		function checkCities(cities){
			if(cities.length<=0 || cities === "No location") return;
			for (var i = cities.length - 1; i >= 0; i--) {
				if (cities[i] && !cities[i].name) {
					cities.splice(i, 1);
				}
			  }
		}
        var canceler;
		var timeoutPromise;
		function onChange(link) {
			if (canceler) {
				canceler.resolve(); // Resolve the previous promise, canceling the request
			}
			canceler = $q.defer();
			timeoutPromise = $timeout(function () {
				// Function to call when user stops typing
				checkLinkGroup(link, canceler.promise);
			}, 500);
		};
		function checkLinkGroup(link) {
			$scope.loading = true;
			$scope.linkChecking = true;
			// $scope.link_error = true;
			if (!link || link.trim() === '') {

				$scope.linkChecking = false;
				$scope.loading = false;
				$scope.chapterCreation = false;
				return;
			}
			var link = link.replace(" ", "_").toLowerCase();
			link = link.replace(/(\s+|\#)/g, "");

			var data = {
				tStart: link,
				exactSeatch: true,
				cid: $scope.cid
			};
			var config = {
				timeout: canceler.promise // Set the canceler promise in the request configuration
			};
			$http.post('./tags3step/fetchTagsToTag', data, config).then(function (res) {

				if (res.data && res.data.success == 1) {
					$scope.loading = false;
					$scope.link_error = true;
					$scope.chapterCreation = false;
				}
				else {
					$scope.loading = false;
					$scope.link_error = false;
					$scope.chapterCreation=true;
				}


			})
			as_upgrade(100);

		}

		function reorderGroups(e) {
			var source_index = e.source.index;
            var dest_index = e.dest.index;
            if( dest_index == source_index )
                return;
            $scope.lock_actions = 2;
			var arr_to_update = {
				data: {
					attributes: {}
				},
				tag_id: $scope.group.id
			};
			arr_to_update.data.attributes.coordinators=[];
			var temp=[];
            angular.forEach($scope.group.coordinators,function(value,key) {
            	if(value.order){
					value.order=key+1;
				}				
            	temp.push(value);
        
            });
			arr_to_update.data.attributes.coordinators=JSON.stringify(temp);
            updateOrdering(arr_to_update);
		}
		function changeMemberAddChoice(val) {
			if(val)
				$scope.membersAddition = true;
			else
				$scope.membersAddition = false;
			as_upgrade(100);
		}
		function updateOrdering(arr_to_update) {
			$http.post('./tags/update',arr_to_update)
			// $http.post('./tags/updateOrder',{c_tags:arr_to_update})
			.then(function(res) {
				if(!res.data || res.data.success != 1){
					snackbar_general($filter('asPortalLang')('Unknown_Err_Refresh',"Something went wrong. Please refresh the page and try again."),4000);
					$timeout( function(){ $scope.lock_actions = 0;as_upgrade(200);}, 100);
				}
				else{
					$scope.lock_actions = 1;
            		$timeout( function(){ $scope.lock_actions = 0;as_upgrade(200);}, 1000);
				}
			});
		}

		function mapToggle()
		{
			$scope.addMapping=!$scope.addMapping;		
			if(!$scope.addMapping)
			{
				$scope.memberscount=false;
				delete $scope.group.newCondition.new_mapping._search;
				delete $scope.group.newCondition.new_mapping._select;
			}
		}

		function check_if_group_has_chat_enabled(){
			if(angular.isDefined($scope.group.attributes.thread_id)){
				$scope.group_chat_enabled =  true;
			}else{
				$scope.group_chat_enabled = false;
			}
		}

		// For getting the chat-setting (who can send the message "all" or "only-admins")
		function check_radio_status(){
			var data = {thread_id : $scope.group.attributes.thread_id};
			$http.post('./messages/get_switch_status',data)
			.then(function(response){
				if(response.data.data) $scope.editData['radio_select']= 'admin';
				else $scope.editData['radio_select']= 'anyone';
				$scope.originalData.radio_select = $scope.editData.radio_select;
			});
		}
		function build_message(used_by) {
			var message ="";
			if(used_by == 'admin'){
				message = $filter('asPortalLang')('Group_Set_Admin_Coord',"[DATA:name] changed this group's settings to allow only admins and group Coordinators to send messages to this group.",{'name': $rootScope.app_data.name});
			}else{
				message =$filter('asPortalLang')('Group_Set_Admin_All',"[DATA:name] changed this group's settings to allow all participants to send messages to this group.",{'name': $rootScope.app_data.name});
			}
			return message;
		}

		function createEditData() {
			$scope.editData = {
				name: $scope.group.name,
				about: $scope.group.attributes.about,
				photo_small: $scope.group.attributes.photo_small,
				link: $scope.group.link
			};
			check_if_group_has_chat_enabled();
			if($scope.group_chat_enabled) check_radio_status();
			$scope.originalData = angular.copy($scope.editData);
		}

		function checkLink() {
			if(!$scope.editData.link || $scope.editData.link.trim() == '') {
				$scope.editData.link_error = true;
				$scope.editData.link_error_text = $filter('asPortalLang')('Group_Link_Err',"Please enter a valid link");
				return;
			}
			else
				$scope.editData.link_error = false;
			groupsService.checkLink($scope.editData,$scope.originalData);
		}

		function checkAbout() {
			if(!$scope.editData.about || $scope.editData.about.trim() == '') {
				$scope.editData.about_error = true;
			}
			else
				$scope.editData.about_error = false;
		}


		function checkName() {
			if(!$scope.editData.name || $scope.editData.name.trim() == '') {
				$scope.editData.name_error = true;
			}
			else
				$scope.editData.name_error = false;
		}

		function loadCroper(){
      var original_epich = angular.element(document.querySelector('#eventPicChange'));
			original_epich.on('change', handleFileSelect);
			original_epich.on('click', function () {
					original_epich.val("");
			});
    }
    function loadCroper2(){
      var new_epich = angular.element(document.querySelector('#eventPicChangeAgain'));
      new_epich.on('change', handleFileSelect);
      new_epich.on('click', function () {
        new_epich.val("");
      });
     }

		function handleFileSelect(evt1) {
			if(evt1.currentTarget.files.length==0) return;
			if (evt1.currentTarget.files.length!=1) {
				swal({text:$filter("asPortalLang")("Group_Upld_One_Img","Please Upload only one image.")});
				return;
			}
			var allowedFileTypes = ['image/jpeg','image/jpg','image/png','image/gif'];
			var file = evt1.currentTarget.files[0];
			var fileType = file.type;
			if(!allowedFileTypes.includes(fileType)) {
      	swal({text:$filter('asPortalLang')('Image_Allowed_Formats',"You may only upload image in the following formats: JPG, JPEG, PNG, GIF. Please re-upload your image.")});
				return false;
	     }
			var reader = new FileReader();
        
      reader.onload = readerOnload;
        
      function readerOnload(evt) {
	      var picChangeData = {
	        imagePath: evt.target.result,
	        aspect_ratio: 1.6,
	        // width: 602,
	        // height: 430,
	        type: "rectangle",
	        target: document.querySelector('#upload_ev_btn_cont'),
	        params: {width: 320, height: 200, resize: true}
	      };
        $scope.$apply(function () {
          $scope.sourceImage = evt.target.result;
          bootModal.pic_change(picChangeData, picChangeCallback);
        });
      }
          
            
     	function picChangeCallback(imageData) {
        if (imageData) {
          if (imageData.data_img !== '') {
          	  $scope.editData.uploadingImages=true;
              var binaryImg=imageData.image_blob;
              binaryImg.name="new_group.jpeg";
              uploadFunction(binaryImg);
          }
        }
     	}
          
    	if (file !== '') {
      	reader.readAsDataURL(file);
    	}
   	}

		function uploadFunction(file) {
	       Upload.upload({
	            url: './welcome/upload',
	            data: {upload:file}
	        }).then(function(response) {
	        	 if (response.data.success==1) {
	                // $scope.disableShare = false;
	        		$scope.editData.photo_small = response.data.data.url;
	        		$scope.editData.photo_small_fullpath = response.data.data.fullpath;
	        		$scope.editData.uploadingImages=false;
	            }
	            else if(angular.isDefined(response.data.error)) {
	                snackbar_general(response.data.error, 3000);
	                $scope.editData.uploadingImages=false;
	            }
	        });
    	}

		function setOriginalData() {
			if($scope.editData.submiting)
				return;
			$scope.editData = angular.copy($scope.originalData);
			$scope.linkChecking=false;
		}

		function updateGroup() {
			var params={};
			if($scope.originalData.radio_select != $scope.editData.radio_select){
				params.chatSendSettings = {};
				params.chatSendSettings.message = build_message($scope.editData.radio_select);
				params.chatSendSettings.thread_id = $scope.group.attributes.thread_id;
			}
			$scope.editData.isChapter = true;
			if($scope.group.extra && angular.isDefined($scope.group.extra.privacy))
				$scope.editData.privacy = $scope.group.extra.privacy;
			groupsService.updateGroup($scope.group.id,$scope.editData,$scope.originalData,params,function() {
				$scope.group.name = $scope.originalData.name;
				$scope.group.link = $scope.originalData.link;
				if($scope.originalData.privacy)
					$scope.group.extra.privacy = $scope.originalData.privacy;
				$scope.group.attributes.about = $scope.originalData.about;
				$scope.group.attributes.photo_small = $scope.originalData.photo_small;
				$scope.editData.radio_select = $scope.originalData.radio_select;
				if($scope.editData.link==$scope.originalData.link){
					var d={'link':$scope.group.link}
					$state.go('.',d,{reload:false,notify:false});
					if(parseInt($scope.group.tag_type) !== 0) {						
						try { $scope.group.limitGroupDescription() }
						catch(e) {}
					}
				}
			});
		}

		function tagSelectedPeople() {
			if($scope.selectedPeople.length == 0) {
				snackbar_general($filter('asPortalLang')('Group_No_Memb_Slct',"No members selected."),3000);
				return;
			}
			$scope.addingSingle = true;
			var alertData = {
					heading: $filter('asPortalLang')('Group_Pepl_Slct',"[DATA:peopleLength] people selected.",{'peopleLength':$scope.selectedPeople.length}),
					body: $filter('asPortalLang')('Group_Will_Added_Msg',"You are about to add [DATA:peopleLength] members. Are you sure?",{'peopleLength':$scope.selectedPeople.length}),
					buttonConfirm: $filter('asPortalLang')('Sure',"Sure"),
					buttonCancel: $filter('asPortalLang')('Cancel',"Cancel"),
					onConfirm: function (callback) {
						var data = {tid:$scope.group.id};
						data.uuis = $scope.selectedPeople.map(function(v) {return v.uui;});
						return $http.post('./tags3step/userBulkTagging',data)
						.then(function(res) {
							if(res.data.success == 1 && res.data.data) {
								$scope.selectedPeople = [];
								snackbar_general($filter('asPortalLang')('Group_Data_Added_Msg',"[DATA:data] people added.",{'data':res.data.data}),2000);
								reloadState();
							}
							else if(res.data.success == 0) {
								$scope.selectedPeople = [];
								snackbar_general($filter('asPortalLang')('Group_Already_Added_Msg',"These people are already added."),3000);
							}
							else {
								snackbar_general($filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime"),5000);
							}
							$scope.addingSingle = false;
							callback();
						})
						.catch(function() {
							snackbar_general($filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime"),5000);
							$scope.addingSingle = false;
							callback();
						});
					},
					onCancel: function (close) {
						$scope.addingSingle = false;
						close(window.event);
					}
			};
			bootModal.alertBox(alertData,document.body);
		}

		function bulkPrompt(event,type) {
			var input = {};
			if(type == "add"){
				input = {
					alertData: "alertData",
					hideTab: 'byName,recentList',
					searchInitialData: {
                        fetchLost:false,
                        fields:{activeStatus: {hidden: false}},
                        authenticated_only:true,
                        categories: [
                            {
                                fields: ['role', "institute", "subinst", "yoj", "yop", "degree", "department", "specialization", "city",'life_membership_number','membership_id','membership_number',"activeStatus","auth_status","chapters","groups", "hometown", "company", "designation", "professional_networks", "industry", "skill", "gender", "dob", "enrollment_number","phone_number","email","account_type","login_status","account_created","import_id","identity_number"],
                                displayName: $filter('asPortalLang')('Filters',"Filters")
                            }
                        ]
                    },
                    options:{noCheckBoxNeeded:true,allowEmptySearch:true,setFormFields:1,mergeFormFields:1,overrideInitialData:true,hideDataOptions:{auth_status:{futherSearchParams:{dropdownList:['rejected','blocked','demised']}}}},
                    extraParams: {}
				}
			}
			else if(type == "delete"){
				input = {
					alertData: "alertData",
					hideTab: 'byName,recentList',
				    searchInitialData: {
				    	dataParams: {tags:[$scope.group.id]},
						contextSearch:{tags:true},
                        fetchLost:false,
                        fields:{activeStatus: {hidden: false}},
                        categories: [
                            {
                                fields: ['role', "institute", "subinst", "yoj", "yop", "degree", "department", "specialization", "city",'life_membership_number','membership_id','membership_number',"activeStatus","auth_status","chapters","groups", "hometown", "company", "designation", "professional_networks", "industry", "skill", "gender", "dob", "enrollment_number","phone_number","email","account_type","login_status","account_created","import_id","identity_number"],
                                displayName: $filter('asPortalLang')('Filters',"Filters")
                            }
                        ]
                    },
                    options:{noCheckBoxNeeded:true,allowEmptySearch:true,setFormFields:1,mergeFormFields:1,overrideInitialData:true,include_demised:true,hideDataOptions:{auth_status:{futherSearchParams:{dropdownList:['rejected','blocked']}}}},
                    extraParams: {}
				}
			}
			ModalService.showModal({
				templateUrl: './templates/modals/material/modalsearch_md_2.html',
				controller: "search-ctrl",
				inputs: input,
				target: event.target
			}).then(function(modal) {
				modal.close.then(function(ml_data) {
					if (ml_data && ml_data.data) {
						if(type == "add")
							addBulkFromQuery(ml_data.data);
						else if(type == "delete")
							removeBulkFromQuery(ml_data.data);
					} else {
						console.log("no list selected");
					}
				});
			});
		}

		function addBulkFromQuery(query) {
			var alertData = {
					heading: $filter('asPortalLang')('Group_Pepl_Slct',"[DATA:peopleLength] people selected.",{'peopleLength':query.count}),
					body: $filter('asPortalLang')('Group_Will_Add_Msg',"You are about to add [DATA:peopleLength] members [DATA:query_string]. In case any person is already added, that person will not be added again.",{'peopleLength':query.count,"query_string": query.query_string})+"<br>"+$filter('asPortalLang')('Profile_Admin_Remove_Confirm',"Are you sure?"),
					buttonConfirm:$filter('asPortalLang')('Sure',"Sure"),
					buttonCancel:$filter('asPortalLang')('Cancel',"Cancel"),
					onConfirm: function (callback) {
						$scope.addingBulk = true;
						var data = {tid:$scope.group.id};
						data.query = query;
						return $http.post('./admin/bulkUserTaggingByQuery',data)
						.then(function(res) {
							if(res.data.success == 1) {
								snackbar_general($filter('asPortalLang')('Group_Data_Added_Msg',"[DATA:data] people added.",{'data':res.data.data},2000));
								reloadState();
							}
							else if(res.data.success == 0) {
								snackbar_general($filter('asPortalLang')('Group_Already_Added_Msg',"These people are already added."),3000);
							}
							else{
								var msg = $filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime");
								if(typeof(res.data.error) == 'string') {
									msg = res.data.error;
								}
								snackbar_general(msg,5000);
							}
							$scope.addingBulk = false;
							callback();
						})
						.catch(function() {
							$scope.addingBulk = false;
							snackbar_general($filter('asPortalLang')('Group_Add_Member_MSg',"We are adding users, please check members count by refreshing page"),5000);
							callback();
						});
					}
			};
			bootModal.alertBox(alertData,document.body);
		}

		function removeSelectedPeople(){
			if($scope.selectedPeopleToRemove.length == 0) {
                snackbar_general($filter('asPortalLang')('Group_No_Memb_Slct',"No members selected."),3000);
                return;
			}
        	$scope.removingSingle = true;
			var alertData = {
				heading: $filter('asPortalLang')('Group_Pepl_Slct',"[DATA:peopleLength] people selected.",{'peopleLength':$scope.selectedPeopleToRemove.length}),
				body: $filter('asPortalLang')('Group_Will_Deleted_Msg',"You are about to remove [DATA:peopleLength] members. Are you sure?",{'peopleLength':$scope.selectedPeopleToRemove.length}),
				buttonConfirm:$filter('asPortalLang')('Sure',"Sure"),
				buttonCancel:$filter('asPortalLang')('Cancel',"Cancel"),
				onConfirm: function (callback) {
					var data = {tid:$scope.group.id};
					data.uuis = $scope.selectedPeopleToRemove.map(function(v) {return v.uui;});
					return $http.post('./tags3step/removeTagMembers',data)
					.then(function(res) {
						if(res.data.success == 1) {
			    			snackbar_general($filter('asPortalLang')('Group_Data_Member_Deleted',"[DATA:data] members deleted.",{'data':$scope.selectedPeopleToRemove.length}),2000)
							$scope.selectedPeopleToRemove = [];
							reloadState();
						}
						else {
					     	snackbar_general($filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime"),5000)
						}
						$scope.removingSingle = false;
						callback();
					})
					.catch(function() {
						snackbar_general($filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime"),5000);
						$scope.removingSingle = false;
						callback();
					});
				},
				onCancel: function (close) {
					$scope.removingSingle = false;
					close(window.event);
				}
			};
			bootModal.alertBox(alertData,document.body);
		}
		
		function searchLocation(data) {
			$scope.locationErr=checkExistingLocation(data);
			if($scope.locationErr){
				snackbar_general($filter('asPortalLang')('Location_Exists',"Location already Exists"),4000);
				return;
			}

			$scope.isFetching=true;
			$scope.group.editing={
				mapping:[]
			};

			var datatype = "current_city";
			var location_type = data.id;
			if(data.place_type && data.place_type != "city"){
				datatype = data.place_type;
				location_type = data.name;
			}

			$scope.group.editing.mapping.push({datatype:datatype,data:location_type});		
			autoAddPeopleInTags(true);
		}

		function checkExistingLocation(data){
			var exists=false;
			if(angular.isDefined($scope.group.mapping) && isArray($scope.group.mapping)){
				$scope.group.mapping.forEach(function(location){
					if(location.data==data.id){
					 	exists=true;
					}
				});		
			}
			return exists;
		}

		function autoAddPeopleInTags(justCount){
			var data2={
				tag_id: $scope.group.id,
				cid: $scope.cid,
				mappings: $scope.group.editing.mapping,
				justCount: justCount
			};
			$scope.memberscount=false;
			$http.post('./tags/autoAddPeopleInTag',data2).then(function(res) {
				$scope.isFetching=false;
				if(data2.justCount && res.data && res.data.success==1)
				{
					$scope.memberscount=true;
					$scope.addMapping=true;
					if(res.data.data.people)
						$scope.group.editing.mapping.membersTobeAdded=res.data.data.people.data;
				}
				else if(!data2.justCount && res.data.success!=1){
					snackbar_general($filter('asPortalLang')('Member_Add_Err',"No [TERM:Members] Added to the [TERM:Chapter:lowercase]",{'data':res.data.data.people.data}),4000);
				}
				else if(!data2.justCount && res.data.success==1){
					snackbar_general($filter('asPortalLang')('Member_Add_Success_Msg',"[DATA:data] [TERM:Members] Added Successfully",{'data':res.data.data.people.data}),4000);
					reloadState();
				}
				else{
					snackbar_general($filter('asPortalLang')('Req_Again',"Please try again"),4000);
				}
			});
		}

		function updateMapping() {
			$scope.lock_actions=2;
			if(!$scope.group.editing)
				return false;
			var data = {
				'tag_id': $scope.group.id,
				'data': {
					'name': $scope.group.name
				}
			};

			if($scope.group.editing.mapping) {
				data.data.mapping =$scope.group.editing.mapping;
			}
	
			$scope.group.updating = true;
			$http.post('./tags/update',data).then(function(res) {
				$scope.group.updating=false;
				if(res.data && res.data.success==1){
					$scope.lock_actions=1;
					var data2={
						'datatype':data.data.mapping[0].datatype,
						'id':data.data.mapping[0].data,
						'tagid':$scope.group.id,
						'name':$scope.group.newCondition.new_mapping._search,
						'data':data.data.mapping[0].data
					}
					if($scope.membersAddition && $scope.group.editing.mapping.membersTobeAdded>0){
						autoAddPeopleInTags(false);
						delete $scope.group.newCondition.new_mapping._search;
						delete $scope.group.newCondition.new_mapping._select;
						
					}
					else{
						delete $scope.group.newCondition.new_mapping._search;
						delete $scope.group.newCondition.new_mapping._select;
					
					}
					if(!isArray($scope.group.mapping))
						$scope.group.mapping=[];
					$scope.group.mapping.push(data2);
					$scope.addMapping=false;
					$scope.memberscount=false;
					$scope.membersAddition=true;
					$scope.group.editing.mapping=[];
					$timeout(function(){
						$scope.lock_actions=0;
					},2000);
				}
				else{
					$scope.lock_actions=0;
				}
			});
		}

		function removeLocationToggle(city) {
				if (!city.hasOwnProperty('showDelete')) {
				  city.showDelete = false; // Initialize showDelete property if not present
				}
				city.showDelete = !city.showDelete;
		}

		function deleteLocation(location,membersDeletion){
			$scope.lock_actions=2;
			$scope.group.editing={
				deletedMapping:[]
			}
			angular.forEach($scope.group.mapping,function(map,i){
				if(location.data==map.data){
					$scope.group.editing.deletedMapping.push(map);
					$scope.group.mapping.splice(i,1);
				}
			});
			var data2={
					'tag_id': $scope.group.id,
					'data': {
						'name': $scope.group.name
					}
			};
					
			if($scope.group.editing.deletedMapping) {
				data2.data.deletedMappings = $scope.group.editing.deletedMapping;
			}
			// chapter.updating = true;
			$http.post('./tags/update',data2)
			.then(function(res) {
				if(res.data && res.data.success==1)
				{
					$scope.lock_actions = 1;
					$timeout( function(){ $scope.lock_actions = 0;as_upgrade(200);}, 1000);									
					if(membersDeletion)
					{
						autoRemovePeopleInTag(data2);
					}
				}
			});			
			function autoRemovePeopleInTag(data)
			{
				$http.post('./tags/autoRemovePeopleInTag',data).then(function(res) {
					if(res.data.success==1){
						snackbar_general($filter('asPortalLang')('Member_Remove_Success_Msg',"[DATA:data] [TERM:Members] Removed Successfully",{'data':res.data.data.people}),4000);
						reloadState();
					}
					else{
						snackbar_general($filter('asPortalLang')('Member_Rmv_Err',"No [TERM:Members] from the location"),4000);
					}
				});
			}		
		}

		function AddCoordModal(group){
			ModalService.showModal({
				templateUrl: './templates/modals/addCoordinatorModal.html',
				controller: ['$scope', 'close', function ($scope, close) {
					$scope.close = close;	
					$scope.addingCoordinator = false;
					$scope.memberName=$filter('asPortalLang')('Member_Name_Req',"Enter name of the [TERM:Member:lowercase]");
					$scope.coordRole=$filter('asPortalLang')('Coordinator_Role_Req',"Enter Coordinator role");			
					group.editing = {
						new_coord: {
						}
					};
					if(!group.attributes) {
						group.attributes = {};
					};
					if(!group.group_privacy)
						group.group_privacy = 0;
					
					if(group.attributes.coordinators) {
						console.log('if', 'group.attribute...ors:', typeof(group.attributes.coordinators));
						group.attributes.coordinators = group.attributes.coordinators.sort(function(a,b) {
							return a.order-b.order;
						});
						group.editing.coordinators = group.attributes.coordinators;
						group.editing.new_coord.order = group.attributes.coordinators.length+1;
					}

					$scope.selectedCoord=selectedCoord;
					$scope.addNewCoord=addNewCoord;
					$scope.updategroup = updategroup; 

					function selectedCoord(data) {
						group.editing.new_coord.uid = data.uid;
						group.editing.new_coord.uui = data.uui;
						group.editing.new_coord.name = data.name;
						group.editing.new_coord.photo = window.s3base+'assets/images/profiles/170x170/'+data.uid+'.jpg';
						group.editing.new_coord_uuis = [];
						group.editing.new_coord_uuis.push(group.editing.new_coord.uui);
					}
					function addNewCoord() {
						if(!group.editing.coordinators) {
							group.editing.coordinators = [];
						}
						if(!group.editing.new_coord.uid || !group.editing.new_coord.uui || !group.editing.new_coord.designation) {
							snackbar_general($filter('asPortalLang')('Req_For_Info',"Please fill all the required information."),2000);
							return false;
						}
						delete group.editing.new_coord._search;
						delete group.editing.new_coord._select;
						if(!group.editing.new_coord.order)
						{
							if(!group.coordinators)
							{
								group.editing.new_coord.order =1;
							}
						}
						group.editing.coordinators.push(angular.copy(group.editing.new_coord));
						group.editing.new_coord = {};
						group.editing.new_coord.order = group.editing.coordinators.length+1;
						group.editing.adding_new_coord=false;
						return true;
					}
					function updategroup(designation) {
						group.editing.new_coord.designation=designation;
						
						var valid=addNewCoord();
						if(!valid){
							return;
						}
						if(!group.editing) {
							return false;
						}
						$scope.addingCoordinator = true;
						var data = {
							data: {
								attributes: {}
							},
							tag_id: group.id
						};
						if(group.editing.coordinators) {
							group.editing.coordinators = group.editing.coordinators.map(function(v) {
								if(v.editing) {
									delete v.editing;
								}
								return v;
							});
							data.data.attributes.coordinators = JSON.stringify(group.editing.coordinators);
							if(group.editing && group.editing.new_coord_uuis)
								data.data.new_coord_uuis = group.editing.new_coord_uuis;
						}
					
						
						$http.post('./tags/update',data).then(function(res) {
							
							if(res.data && res.data.success == 1) {
								snackbar_general($filter('asPortalLang')('Coord_Add_Success_Msg',"[TERM:Coordinator] Added Successfully"),2000);
								if(group.editing.coordinators) {
									group.coordinators=group.editing.coordinators;
								}
								$scope.addingCoordinator = false;
								reloadState();
								close();
								as_upgrade(100);
							}
							else {
								$scope.addingCoordinator = false;
								snackbar_general($filter('asPortalLang')('Req_Again',"Please try again"),2000);
							}
						})
						.catch(function(err) {
							$scope.addingCoordinator = false;
						});
					}
				
					
				}],
				target: event.target
			}).then(backClose);

			function backClose(modal) {
				modalBackClose(modal);
			}
			as_upgrade(100);
		}
		function deleteCoordModal(coord,group){
			if(coord.uui==$rootScope.app_data.logged_user_roles[0].uui)
				return;
			ModalService.showModal({
				templateUrl: './templates/modals/deleteCoordinatorModal.html',
				controller: ['$scope', 'close', function ($scope, close) {
					
					$scope.close = close;
					
					$scope.CoordDelete = {};
					$scope.CoordDelete=coord;
					$scope.coordName={'coordName':coord.name};
					$scope.updategroup = updategroup; 
					
					
					function deleteCoord() {
						var coords=group.coordinators;
						angular.forEach(coords, function(c,i){
							if(c.uid==$scope.CoordDelete.uid){
								coords.splice(i,1);				}
							});						
						// arr_to_update.data.attributes.coordinator=[];
						var temp=[];
		            	angular.forEach(coords,function(value,key) {
		            		if(value.order){
								value.order=key+1;
							}
							temp.push(value);
            			});
						return JSON.stringify(temp);
					}
					function updategroup() {
						var data = {
							data: {
								attributes: {}
							},
							tag_id: group.id
						};
						$scope.deleteCoordinator = true;
						// group.editing.new_coord.designation=designation;
						data.data.attributes.coordinators=deleteCoord();

						// group.editing.submiting = true;
						$http.post('./tags/update',data).then(function(res) {
							// group.editing.submiting = false;
							if(res.data && res.data.success == 1) {
								snackbar_general($filter('asPortalLang')('Coord_Remove_Success_Msg',"[TERM:Coordinator] Removed Successfully"),2000);
								close();
							}
							else {
								snackbar_general($filter('asPortalLang')('Req_Again',"Please try again"),2000);
							}
							$scope.deleteCoordinator =false;
						})
						.catch(function(err) {
							// group.editing.submiting = false;
							$scope.deleteCoordinator =false;
						});
					}
				}],
				target: event.target
			}).then(backClose);

			function backClose(modal) {
				modalBackClose(modal);
			}
			as_upgrade(100);
		}


		function editCoordModal(coord,param,group){
			if(coord.uui==$rootScope.app_data.logged_user_roles[0].uui)
				return;
			ModalService.showModal({
				templateUrl: './templates/modals/addCoordinatorModal.html',
				controller: ['$scope', 'close', function ($scope, close) {
					$scope.close = close;
					$scope.param=param;
					$scope.editingCoord=false;
					$scope.addingCoordinator=false;
					$scope.coordInfo={
						uid:coord.uid,
						name:coord.name,
						designation:coord.designation
						
					};
					group.editing = {
						// name: group.name,
						new_coord: {}
					};
					$scope.selectedCoord=selectedCoord;
					$scope.editCoord=editCoord;
					$scope.updategroup=updategroup;
					$scope.onChange=onChange;

					function selectedCoord(data) {						
						group.editing.new_coord.uid = data.uid;
						group.editing.new_coord.uui = data.uui;
						group.editing.new_coord.name = data.name;
						group.editing.new_coord.photo = window.s3base+'assets/images/profiles/170x170/'+data.uid+'.jpg';
						group.editing.new_coord_uuis = [];
						group.editing.new_coord_uuis.push(group.editing.new_coord.uui);
						$scope.editingCoord = true;
						// console.log(group);
					}
					function  onChange(designation){
						group.editing.new_coord.designation = designation;
						$scope.editingCoord = true;	
					}
					function editCoord(){
						var temp=group.coordinators;
						if(!angular.equals(group.editing.new_coord,{}))
						{
							angular.forEach(temp,function(c,i){
								if(c.uid==$scope.coordInfo.uid){
									for (var prop in group.editing.new_coord) {
										if (c.hasOwnProperty(prop)) {
									  		c[prop] = group.editing.new_coord[prop];
									  		delete group.editing.new_coord[prop];
										}
								  	}
								}
							});
							return JSON.stringify(temp);
						}
						return false;
						// console.log(group);
					}
					function updategroup(){
						var data = {
							data: {
								attributes: {}
							},
							tag_id: group.id
						};
						var info=editCoord();
						if(!info)
							return false;
						$scope.addingCoordinator =true;
						data.data.attributes.coordinators=info;
						if(group.editing && group.editing.new_coord_uuis)
							data.data.new_coord_uuis = group.editing.new_coord_uuis;
						group.editing.submiting = true;
						$http.post('./tags/update',data).then(function(res) {
							// group.editing.submiting = false;
							if(res.data && res.data.success == 1) {
								snackbar_general($filter('asPortalLang')('Group_Info_Update_Msg',"Group information updated successfully."),2000);
								$scope.addingCoordinator = false;
								reloadState();
								close();
								
							}
							else {
								$scope.addingCoordinator = false;
								snackbar_general($filter('asPortalLang')('Req_Again',"Please try again"),2000);
							}
						}).catch(function(err) {
							$scope.addingCoordinator = false;
							// group.editing.submiting = false;
						});
					}
				}],
				target: event.target
			}).then(backClose);

			function backClose(modal) {
				modalBackClose(modal);

			}
			as_upgrade(100);
		}

		
		function removeBulkFromQuery(query) {
			var alertData = {
					heading: $filter('asPortalLang')('Group_Pepl_Slct',"[DATA:peopleLength] people selected.",{'peopleLength':query.count}),
					body: $filter('asPortalLang')('Group_Will_Delete_Msg',"You are about to delete [DATA:peopleLength] members [DATA:query_string].",{'peopleLength':query.count,"query_string": query.query_string})+"<br>"+$filter('asPortalLang')('Profile_Admin_Remove_Confirm',"Are you sure?"),
					buttonConfirm:$filter('asPortalLang')('Sure',"Sure"),
					buttonCancel:$filter('asPortalLang')('Cancel',"Cancel"),
					onConfirm: function (callback) {
						$scope.removingBulk = true;
						var data = {tid:$scope.group.id};
						data.query = query;
						data.removeTagMembers = true;
						return $http.post('./admin/bulkUserTaggingByQuery',data)
						.then(function(res) {
							if(res.data.success == 1) {								
								snackbar_general($filter('asPortalLang')('Group_Data_Deleted_Msg',"[DATA:data] people deleted.",{'data':res.data.data}),2000);
								reloadState();
							}
							else{
								var msg = $filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime");
								if(typeof(res.data.error) == 'string') {
									msg = res.data.error;
								}
								snackbar_general(msg,5000);
							}
							$scope.removingBulk = false;
							callback();
						})
						.catch(function() {
							$scope.removingBulk = false;
							snackbar_general($filter('asPortalLang')('Profile_Unknown_Try_Err',"Something went wrong. Please try again after sometime"),3000);
							callback();
						});
					}
			};
			bootModal.alertBox(alertData,document.body);
		}

		function reloadState() {
            $state.reload();
        }

        function goBackToPrevPage() {
        	if($scope.goToMainGroup)
        		$state.go('inapp.group_detail.main',{link: $scope.group.link});
        	else
				window.history.back();	
		}
		function goBackToPrevPage2(){
			
			if($scope.goToMainGroup)
			{
				if(!$rootScope.app_data.isAdmin)
					return false;
				$state.go('inapp.admin',{category:'chapters',tab:'chapter_list'});
			}
			else{
				$state.go('inapp.chapter_detail.main',{link: $scope.group.link});
			}
		}


		function goToAdminDashboard() {
			if(!$rootScope.app_data.isAdmin)
				return false;
			$state.go('inapp.admin',{category: 'groups', tab: 'group_list', id: $scope.group.id});
		}

	}
})();